var _rect, _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 206,
    viewBox: "0 0 360 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 352,
    height: 180,
    rx: 12,
    fill: "url(#paint0_linear_231_21510)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_231_21510)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 352,
    height: 170,
    rx: 12,
    fill: "white",
    fillOpacity: 0.03
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.292 161.473C319.73 161.675 320 162.112 320 162.595C320 172.207 312.207 180 302.595 180H17.4054C7.79266 180 0 172.207 0 162.595V37.1853C0 31.0576 4.6574 25.8806 10.7682 25.426C96.783 19.0268 112.667 55.4987 127.868 90.4044C141.159 120.923 153.929 150.244 212.593 148.669C265.775 147.241 299.74 152.439 319.292 161.473Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.598 189.58C177.808 197.117 171.955 206 163.322 206H17.4054C7.79265 206 0 198.207 0 188.594V160.487C0 154.85 3.974 149.947 9.50005 148.833C116.936 127.18 153.483 153.563 173.598 189.58Z",
    fill: "white",
    fillOpacity: 0.08
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_231_21510",
    x: -61.6216,
    y: -59.6216,
    width: 491.243,
    height: 309.243,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 34.8108
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_21510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_21510",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_21510",
    x1: -42.4358,
    y1: -19.4595,
    x2: 393.743,
    y2: 227.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122247,
    stopColor: "#52B6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878935,
    stopColor: "#0671DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTemplate);
export default __webpack_public_path__ + "static/media/cardTemplate.3d176cabe93c39af10d74f36bc72f920.svg";
export { ForwardRef as ReactComponent };